import { camelizeKeys } from '@betterment/js-runtime';
import { LoaderFunction, redirectDocument } from 'react-router-dom';

export const loadInitialProps: LoaderFunction = async ({ request }) => {
  const response = await fetch(request.url, {
    headers: { Accept: 'application/json' },
  });

  if (response.ok) {
    return camelizeKeys(((await response.json()) as { data: object }).data);
  }

  // If the page requires sudo mode, reload
  if (response.status === 401) {
    return redirectDocument(request.url);
  }

  throw new Error(`Failed to load initial props: ${response.status}`);
};
